import React from 'react';
import { Layout, Menu, Avatar, Dropdown, Button } from 'antd';
import { 
  UserOutlined,
  LoginOutlined,
  LogoutOutlined 
} from '@ant-design/icons';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../utils/auth';

const { Header, Content } = Layout;

const menuItems = [
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'Subscription',
    path: '/payment',
  },
  {
    label: 'Requests',
    path: '/requests',
  },
];

const menuItemsAuthenticated = [
  {
    label: 'Profile',
    path: '/profile',
  },
  {
    label: 'Subscription',
    path: '/payment',
  },
  {
    label: 'Requests',
    path: '/requests',
  },
];

function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, login, logout } = useAuth();
  const isAuthenticated = !!user;

  const menu = (
    <Menu theme="dark" style={{ marginTop: '10px' }}>
      <Menu.Item key="login" onClick={() => login()}>
        <LoginOutlined />
        <span>Sign In</span>
      </Menu.Item>
      <Menu.Item key="register" onClick={() => login()}>
        <Button type="primary">Sign Up</Button>
      </Menu.Item>
    </Menu>
  );

  const userMenu = (
    <Menu theme="dark">
      <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="settings">
        Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const renderMenuItems = () => {
    const items = isAuthenticated ? menuItemsAuthenticated : menuItems;
    return items.map(item => (
      <Menu.Item key={item.label} onClick={() => navigate(item.path)}>
        {item.label}
      </Menu.Item>
    ));
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#001529' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo-hd.png" alt="Bingeit.VIP Test" style={{ height: '36px', marginRight: '8px', objectFit: 'contain' }} />
            <span style={{ color: 'white', fontSize: '22px', fontWeight: 'bold' }}>Bingeit.VIP</span>
          </Link>
        
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          style={{ marginTop: '10px' }}
        >
          {renderMenuItems()}
        </Menu>

        {isAuthenticated ? (
          <Dropdown overlay={userMenu} placement="top-right">
            <Avatar src={user.avatar} style={{ cursor: 'pointer', marginLeft: '20px' }} />
          </Dropdown>
        ) : (
          <Dropdown overlay={menu} placement="top-right">
            <span style={{ cursor: 'pointer', marginLeft: '20px', color: 'white' }}>
              Sign In
            </span>
          </Dropdown>
        )}
      </Header>

      <Content style={{ margin: '20px', padding: '20px' }}>
        <Outlet />
      </Content>
    </Layout>
  );
}

export default AppLayout;